import React, { Component } from "react";
import { Form, BackTop } from "antd";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import {
  notificationMessage,
  notificationTitle,
  openNotificationType,
} from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import GeneralDetails from "../../Registration/RegistrationFormView/Components/GeneralDetails";
import TaxationDetails from "../../Registration/RegistrationFormView/Components/TaxationDetails";
import LogisticsDetail from "../../Registration/RegistrationFormView/Components/LogisticsDetails";
import AdditionalDetails from "../../Registration/RegistrationFormView/Components/AdditionalDetails";
import PaymentDetails from "../../Registration/RegistrationFormView/Components/PaymentDetails";
import FMEDetails from "../../Registration/RegistrationFormView/Components/FMEDetails";
import RegistrationDataProvider from "../../Registration/RegistrationFormView/RegistrationDataProvider";
import {
  DEPENDENT_DROPDOWN_FIELDS,
  DROPDOWN_FIELDS,
  FIELD_ALIAS,
  MULTIVALUE_FIELDS,
  STATUS_WISE_RESET_FIELDS,
  CONVERT_TO_TYPE,
  NOTIFICATIONS,
  FILE_UPLOAD_FIELDS,
  SUBMIT_VALUES,
  URLS,
  INDIA,
  SCROLL_TO_FIELD_FOR_FILE,
  SCROLL_TO_FIELD_SERIA,
  SCREEN_ROUTES,
} from "../../../constants";
import {
  downloadFileFromServer,
  downloadFileLocal,
} from "../../Registration/RegistrationFormView/RegistrationFormViewHelper";
import CustomLoader from "../../Registration/RegistrationFormView/Components/CustomLoader";
import CustomHeader from "../../Registration/RegistrationFormView/Components/CustomHeader";
import CustomFooter from "../../Registration/RegistrationFormView/Components/CustomFooter";

class CustomerListView extends Component {
  formRef = React.createRef();
  path = this.props.history.location.pathname;
  route = !this.path.includes(URLS.REGISTRATION)
    ? this.path.split("/").pop()
    : undefined;
  isDisabled = window.location.pathname.includes(
    SCREEN_ROUTES.VIEW_REGISTRATION_FORM
  );

  DataProvider = new RegistrationDataProvider();

  state = {
    isLoading: false,
    showSkeleton: false,
    message: NOTIFICATIONS.PLEASE_WAIT,
    versionList: [],
    //BELOW ARE FOR FILE UPLOADS
    uploadedFiles: {},
    fileConfigs: {},
    //BELOW ARE FOR MAINTAINING DISABLED FIELDS
    gst_registration_status: false,
    tcs_applicable_status: false,
    cin_number_status: false,
    //BELOW ARE FOR TC, INSTRUCTIONS
    agreeINS: false,
    agreeTC: false,
    //BELOW ARE FOR SECTION VISIBILITY
    taxationVisible: false,
    //BELOW ARE FOR ADDITIONAL DETAILS ONLY WHEN EDIT FORM
    additional_details: {
      customer_email: [],
      director_details: [],
      sister_company_details: [],
    },
    //BELOW ARE FOR DROPDOWNS
    country: null,
    fmeData: [],
    statesData: [],
    citiesData: [],
    otherCity: [],
    othertype: {},
    //BELOW ARE FOR DROPDOWN BASED CONDITIONS
    pincodeLength: 0,
    //BELOW ARE FOR EDIT DATA
    editDataAvailable: false,
    isInEdit: this.route !== undefined ? true : false,
  };

  componentDidMount() {
    this.getFileConfig();

    if (this.state.isInEdit) {
      this.getUserData();
      this.getVersionHistory();
    }
  }

  getUserData = () => {
    try {
      this.setState({ isLoading: true, agreeINS: true });
      this.DataProvider.get_user_data_api(this.route)
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              this.getAllFmes(res.employee_name);
              this.getFileConfig();

              //TO SET MULTIPLE VALUE FIELDS
              let additional_details = {};
              Object.keys(MULTIVALUE_FIELDS).forEach((decorator) => {
                additional_details[decorator] =
                  res[decorator] !== undefined && res[decorator].length > 0
                    ? res[decorator]
                    : [{ id: 0, value: "" }];
              });
              this.setState({ additional_details, editDataAvailable: true });

              //TO MANAGE ALIAS FIELDS
              Object.keys(FIELD_ALIAS).map((key) => {
                res[FIELD_ALIAS[key].decorator] = res[FIELD_ALIAS[key].field];
                delete res[FIELD_ALIAS[key].field];
              });

              //CONVERT DATA TO PARTICULAR DATA TYPE
              CONVERT_TO_TYPE.map((t) => {
                res[t.decorator] = t.type(res[t.decorator]);
              });

              //TO SET FILES
              let uploadedFiles = {};
              try {
                Object.keys(FILE_UPLOAD_FIELDS).map((decorator) => {
                  let fileList = res.files.filter(
                    (f) => f.category === decorator
                  );
                  uploadedFiles = { ...uploadedFiles, [decorator]: fileList };
                  this.formRef.current.setFieldsValue({
                    [decorator]: fileList,
                  });
                });
              } catch (error) {}

              //TO ENABLE/DISABLE TAXATION SECTION BASED ON COUNTRY
              const isCountryInd =
                res.country_name.toString().toLowerCase() === INDIA;
              const isOtherCity =
                res.other_city !== null
                  ? [{ city_id: 0, name: res.other_city, other: true }]
                  : [];

              this.setState(
                {
                  otherCity: isOtherCity,
                  taxationVisible: isCountryInd,
                  pincodeLength: isCountryInd ? 6 : 10,
                  uploadedFiles,
                },
                () => {
                  if (this.state.taxationVisible) {
                    //TOGGED HTML CONTROL ENABLE/DISABLE BASED ON DATA RECEIVED
                    Object.keys(STATUS_WISE_RESET_FIELDS).map((decorator) => {
                      if (res[decorator] === true) {
                        this.setState({ [decorator]: true });
                      }
                    });
                  }
                }
              );

              //TO LOAD DEPENDENT DATA
              this.get_dropdown_dependent_data(
                DEPENDENT_DROPDOWN_FIELDS.state.app,
                DEPENDENT_DROPDOWN_FIELDS.state.model,
                DEPENDENT_DROPDOWN_FIELDS.state.dependent,
                res.country,
                DEPENDENT_DROPDOWN_FIELDS.state.storein
              );

              this.get_dropdown_dependent_data(
                DEPENDENT_DROPDOWN_FIELDS.city.app,
                DEPENDENT_DROPDOWN_FIELDS.city.model,
                DEPENDENT_DROPDOWN_FIELDS.city.dependent,
                res.state,
                DEPENDENT_DROPDOWN_FIELDS.city.storein
              );

              //TO SET FIELDS VALUE
              try {
                Object.keys(res).map((decorator) => {
                  this.formRef.current.setFieldsValue({
                    [decorator]: res[decorator],
                  });
                });
              } catch (error) {
                console.error(error);
              }
            });
          } else if (res.status === 403) {
            return res.json().then((res) => {
              Object.keys(res).map((k) => {
                openNotification(openNotificationType.error, k, res[k]);
              });

              this.props.history.push(URLS.BASEROUTE);
            });
          } else {
            return res.json().then((res) => {
              Object.keys(res).map((k) => {
                openNotification(openNotificationType.error, k, res[k]);
              });
            });
          }
        })
        .finally(() => this.setState({ isLoading: false }));
    } catch (error) {
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  onFinish = (values) => {
    //GST NUMBER SHOULD CONTAIN PAN NUMBER
    if (values.gst_number !== undefined && values.gst_number !== null) {
      if (!values.gst_number.includes(values.pan_number)) {
        this.formRef.current.scrollToField(
          SCROLL_TO_FIELD_FOR_FILE.gst_document[0]
        );

        this.formRef.current.setFields([
          {
            name: SCROLL_TO_FIELD_FOR_FILE.gst_document[0],
            errors: NOTIFICATIONS.VALIDATE_GST,
          },
        ]);
        return;
      }
    }

    Object.keys(MULTIVALUE_FIELDS).map((each_field) => {
      let new_list = [];
      values[each_field].map((each_record) => {
        if (each_record !== undefined) {
          if (each_record.value !== "")
            new_list = [...new_list, each_record.value];
        }
      });
      values[each_field] = new_list;
    });

    //TO MANAGE SELETED OTHERTYPE FROM CMB
    let { othertype, otherCity } = this.state;
    Object.keys(othertype).map((key) => {
      delete values[key];
      values[`${SUBMIT_VALUES.OTHER}_${key}`] = othertype[key].name;
    });

    if (values.city === 0) {
      delete values.city;
      values[`${SUBMIT_VALUES.OTHER}_${DROPDOWN_FIELDS.city}`] =
        otherCity[0].name;
    }

    //TO MANAGE ALIAS FIELDS
    Object.keys(FIELD_ALIAS).map((key) => {
      values[FIELD_ALIAS[key].field] = values[FIELD_ALIAS[key].decorator];
      delete values[FIELD_ALIAS[key].decorator];
    });

    let formData = new FormData();

    //TO MANAGE MULTIPLE UPLOADED FILES
    let oldFiles = [];
    var { uploadedFiles } = this.state;
    Object.values(FILE_UPLOAD_FIELDS).forEach((v) => {
      if (uploadedFiles[v] != null) {
        uploadedFiles[v].forEach((file, index) => {
          if (file && file.status) {
            file.attachment_type = v;
            oldFiles.push(file);
          } else {
            formData.append(`${v}${index}`, file);
          }
        });
      } else {
        formData.append(v, null);
      }
      delete values[v];
    });

    formData.append(SUBMIT_VALUES.OLD_FILES, JSON.stringify(oldFiles));
    formData.append(SUBMIT_VALUES.DATA, JSON.stringify(values));

    //IF isInEdit = true THEN UPDATE DATA ELSE INSERT DATA
    if (this.state.isInEdit) {
      this.updateCustomer(formData);
    } else {
      this.registerCustomer(formData);
    }
  };

  onFinishFailed = (values) => {
    this.formRef.current.scrollToField(values.errorFields[0].name);

    Object.keys(SCROLL_TO_FIELD_FOR_FILE).map((decorator) => {
      if (decorator === values.errorFields[0].name[0]) {
        this.formRef.current.scrollToField(SCROLL_TO_FIELD_FOR_FILE[decorator]);
      }
    });

    //SHOW ERROR NOTIFICATION
    try {
      if (values.errorFields.length > 3) {
        openNotification(
          openNotificationType.error,
          notificationTitle.form,
          NOTIFICATIONS.FORM_VALIDATION
        );
      } else {
        values.errorFields.map((each) => {
          openNotification(
            openNotificationType.error,
            notificationTitle.form,
            each.errors[0]
          );
        });
      }
    } catch (error) {}
  };

  get_dropdown_dependent_data = (app, model, dependent, id, state) => {
    try {
      this.DataProvider.get_dependent_dropdown_data_api(
        app,
        model,
        dependent,
        id,
        state
      ).then((res) => {
        if (res.ok) {
          return res.json().then((res) => this.setState({ [state]: res }));
        } else {
          openNotification(
            openNotificationType.error,
            NOTIFICATIONS.ERROR_OCCURED,
            NOTIFICATIONS.REFRESH_PAGE
          );
        }
      });
    } catch (error) {
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  registerCustomer = (formData) => {
    try {
      this.setState(
        { isLoading: true, message: NOTIFICATIONS.SAVING_DATA },
        () =>
          setTimeout(() => {
            this.setState({ message: NOTIFICATIONS.UPLOADING_FILES });
          }, 2000)
      );

      this.DataProvider.registration_customer_api(formData)
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              this.props.history.push(URLS.REGISTER_SUCCESS);
            });
          } else {
            return res.json().then((res) => {
              let errorFieldName = Object.keys(res)[0];
              this.formRef.current.scrollToField(errorFieldName);

              Object.keys(res).map((k) => {
                let title = k.replace("_", " ").replace("_", " ");
                title = title.charAt(0).toUpperCase() + title.slice(1);

                openNotification(openNotificationType.error, title, res[k]);

                // FOR FIELDS WHICH ARE DIFFRENT FROM BACK AND FRONT
                if (SCROLL_TO_FIELD_SERIA[k] !== undefined) {
                  k = SCROLL_TO_FIELD_SERIA[k];
                }
                this.formRef.current.setFields([
                  {
                    name: k,
                    errors: res[k],
                  },
                ]);
              });
            });
          }
        })
        .finally(() =>
          this.setState({
            isLoading: false,
            message: NOTIFICATIONS.PLEASE_WAIT,
          })
        );
    } catch (error) {
      this.setState({ isLoading: false, message: NOTIFICATIONS.PLEASE_WAIT });
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  updateCustomer = (formData) => {
    try {
      this.setState({ isLoading: true });
      this.DataProvider.update_customer_api(this.route, formData)
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              openNotification(
                openNotificationType.success,
                notificationTitle.form,
                NOTIFICATIONS.FORM_UPDATED_SUCCESS
              );

              setTimeout(() => {
                window.location.reload();
              }, 500);
            });
          } else {
            return res.json().then((res) => {
              let errorFieldName = Object.keys(res)[0];
              this.formRef.current.scrollToField(errorFieldName);

              Object.keys(res).map((k) => {
                let title = k.replace("_", " ").replace("_", " ");
                title = title.charAt(0).toUpperCase() + title.slice(1);

                openNotification(openNotificationType.error, title, res[k]);

                // FOR FIELDS WHICH ARE DIFFRENT FROM BACK AND FRONT
                if (SCROLL_TO_FIELD_SERIA[k] !== undefined) {
                  k = SCROLL_TO_FIELD_SERIA[k];
                }
                this.formRef.current.setFields([
                  {
                    name: k,
                    errors: res[k],
                  },
                ]);
              });
            });
          }
        })
        .finally(() => this.setState({ isLoading: false }));
    } catch (error) {
      this.setState({ isLoading: false });
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  getVersionHistory = () => {
    try {
      this.DataProvider.get_version_history_api(this.route).then((res) => {
        if (res.ok) {
          return res.json().then((res) => {
            this.setState({ versionList: res });
          });
        } else {
          return res.json().then((res) => {
            Object.keys(res).map((k) => {
              openNotification(openNotificationType.error, k, res[k]);
            });
          });
        }
      });
    } catch (error) {
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  onBackPressed = () => {
    this.props.history.goBack();
  };

  removeFile = (file, decorator) => {
    try {
      var { uploadedFiles } = this.state;
      if (uploadedFiles.hasOwnProperty(decorator)) {
        uploadedFiles[decorator] = uploadedFiles[decorator].filter(
          (f) => f && f.uid !== file.uid
        );
        this.setState({ uploadedFiles: uploadedFiles });
      }
    } catch (error) {
      console.error(`Exception raised for ${decorator} with value ${file}`);
      console.error(error);
    }
  };

  addFile = (file, decorator) => {
    try {
      let { uploadedFiles } = this.state;
      this.setState({
        uploadedFiles: {
          ...uploadedFiles,
          [decorator]:
            uploadedFiles[decorator] !== undefined
              ? [...uploadedFiles[decorator], file]
              : [file],
        },
      });
    } catch (error) {
      console.error(`Exception raised for ${decorator} with value ${file}`);
      console.error(error);
    }
  };

  goToLogin = () => {
    this.props.history.push("Login");
  };

  handleChange = (decorator, value) => {
    try {
      if (decorator === DROPDOWN_FIELDS.country) {
        //RESET CITY STATE
        this.formRef.current.resetFields([
          DROPDOWN_FIELDS.state,
          DROPDOWN_FIELDS.city,
        ]);

        //TO LOAD STATES
        this.get_dropdown_dependent_data(
          DEPENDENT_DROPDOWN_FIELDS.state.app,
          DEPENDENT_DROPDOWN_FIELDS.state.model,
          DEPENDENT_DROPDOWN_FIELDS.state.dependent,
          value.country_id,
          DEPENDENT_DROPDOWN_FIELDS.state.storein
        );

        //TO TOGGLE TAXATION SECTION
        value.name.toString().toLowerCase() === "india"
          ? this.setState({ taxationVisible: true, pincodeLength: 6 })
          : this.setState({ taxationVisible: false, pincodeLength: 10 });

        //RESET TAXATION DETAILS SECTION
        Object.keys(STATUS_WISE_RESET_FIELDS).map((each_key) => {
          this.formRef.current.resetFields([
            ...STATUS_WISE_RESET_FIELDS[each_key],
            each_key,
          ]);
        });

        let { uploadedFiles } = this.state;
        Object.keys(uploadedFiles).map((decorator) => {
          if (decorator !== FILE_UPLOAD_FIELDS.balance_sheet_file) {
            delete uploadedFiles[decorator];
          }
        });
        this.setState({ uploadedFiles });
      }

      if (decorator === DROPDOWN_FIELDS.state) {
        //RESET CITY
        this.formRef.current.resetFields([DROPDOWN_FIELDS.city]);

        //TO LOAD CITIES
        this.get_dropdown_dependent_data(
          DEPENDENT_DROPDOWN_FIELDS.city.app,
          DEPENDENT_DROPDOWN_FIELDS.city.model,
          DEPENDENT_DROPDOWN_FIELDS.city.dependent,
          value.state_id,
          DEPENDENT_DROPDOWN_FIELDS.city.storein
        );
      }

      if (decorator === DROPDOWN_FIELDS.city) {
        if (value[SUBMIT_VALUES.OTHER] !== undefined) {
          let { othertype } = this.state;
          this.setState({ othertype: { ...othertype, [decorator]: value } });
        } else {
          delete this.state.othertype[decorator];
        }
      }

      if (decorator === DROPDOWN_FIELDS.fme) {
        this.formRef.current.setFieldsValue({
          fme_name: `${value.email}`,
        });
      }
    } catch (error) {
      console.error(`Exception ${decorator} with value ${value}`);
      console.error(error);
    }
  };

  handleSearch = (decorator, value) => {
    try {
      if (decorator === DROPDOWN_FIELDS.fme) {
        if (value.length >= 3) {
          this.getAllFmes(value);
        }
      }
    } catch (error) {
      console.error(`Exception ${decorator} with value ${value}`);
      console.error(error);
    }
  };

  getAllFmes = (query) => {
    try {
      this.DataProvider.get_all_fmes_api(query).then((res) => {
        if (res.ok) {
          return res.json().then((res) => this.setState({ fmeData: res }));
        } else {
          openNotification(
            openNotificationType.error,
            NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
          );
        }
      });
    } catch (error) {
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  getFileConfig = () => {
    try {
      this.DataProvider.get_file_config_api().then((res) => {
        if (res.ok) {
          return res.json().then((res) => this.setState({ fileConfigs: res }));
        } else {
          openNotification(
            openNotificationType.error,
            NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
          );
        }
      });
    } catch (error) {
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  agreeToIns = (agreeINS) => {
    this.setState({ agreeINS, agreeTC: false });
  };

  toggleHTMLControls = (decorator, value) => {
    let { uploadedFiles } = this.state;

    this.setState({ [decorator]: value }, () => {
      if (!value) {
        this.formRef.current.resetFields(STATUS_WISE_RESET_FIELDS[decorator]);

        STATUS_WISE_RESET_FIELDS[decorator].map((each_field) => {
          if (uploadedFiles[each_field] !== undefined) {
            uploadedFiles[each_field].map((each_file) => {
              this.removeFile(each_file, each_field);
            });
          }
        });
      }
    });
  };

  downloadFile = (values) => {
    try {
      this.DataProvider.download_file_api(values.uid).then((res) => {
        if (res.ok) {
          res.blob().then((blob) => {
            downloadFileFromServer(blob, values);
          });
        } else {
          if (res.status == 400) {
            res.json().then((res) => {
              openNotification(
                openNotificationType.error,
                notificationTitle.api,
                res.message
              );
            });
          } else {
            var file = values;
            downloadFileLocal(file);
          }
        }
      });
    } catch (error) {
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  onClear = (decorator) => {
    try {
      if (decorator === DROPDOWN_FIELDS.fme) {
        this.formRef.current.setFieldsValue({
          fme_name: "",
        });
      }
    } catch (error) {
      console.error(`Exception ${decorator}`);
      console.error(error);
    }
  };

  validateGSTNumber = (decorator, value) => {
    try {
      //GST NUMBER SHOULD CONTAIN PAN NUMBER
      if (value !== undefined && value !== null) {
        const pan_num = this.formRef.current.getFieldsValue(
          SCROLL_TO_FIELD_FOR_FILE.pan_document[0]
        );

        if (!value.includes(pan_num)) {
          this.formRef.current.scrollToField(
            SCROLL_TO_FIELD_FOR_FILE.gst_document[0]
          );

          this.formRef.current.setFields([
            {
              name: SCROLL_TO_FIELD_FOR_FILE.gst_document[0],
              errors: NOTIFICATIONS.VALIDATE_GST,
            },
          ]);
          return;
        }
      }
    } catch (error) {
      console.error(`Exception ${decorator} with value ${value}`);
      console.error(error);
    }
  };

  render() {
    const {
      isLoading,
      agreeINS,
      agreeTC,
      uploadedFiles,
      taxationVisible,
      fmeData,
      statesData,
      pincodeLength,
      fileConfigs,
      citiesData,
      otherCity,
      isInEdit,
      gst_registration_status,
      tcs_applicable_status,
      cin_number_status,
      additional_details,
      editDataAvailable,
      versionList,
      message,
      showSkeleton,
    } = this.state;

    return (
      <Form
        ref={this.formRef}
        className={`ant-form ant-form-vertical ${!isInEdit && "p-5"}`}
        onFinish={this.onFinish}
        onFinishFailed={this.onFinishFailed}
      >
        {isLoading && <CustomLoader message={message} />}

        <CustomHeader
          isInEdit={isInEdit}
          goToLogin={this.goToLogin}
          agreeToIns={this.agreeToIns}
          onBackPressed={this.onBackPressed}
          formRef={this.formRef}
          disabled={this.isDisabled}
        />

        <div hidden={!agreeINS}>
          <GeneralDetails
            formRef={this.formRef}
            handleChange={this.handleChange}
            statesData={statesData}
            citiesData={[...citiesData, ...otherCity]}
            pincodeLength={pincodeLength}
            isDisabled={this.isDisabled}
          />

          {taxationVisible && (
            <TaxationDetails
              formRef={this.formRef}
              addFile={this.addFile}
              removeFile={this.removeFile}
              uploadedFiles={uploadedFiles}
              fileConfigs={fileConfigs}
              gst_registration_status={gst_registration_status}
              tcs_applicable_status={tcs_applicable_status}
              cin_number_status={cin_number_status}
              toggleHTMLControls={this.toggleHTMLControls}
              previewFile={this.downloadFile}
              isDisabled={this.isDisabled}
              validateGSTNumber={this.validateGSTNumber}
            />
          )}

          <PaymentDetails
            formRef={this.formRef}
            addFile={this.addFile}
            removeFile={this.removeFile}
            uploadedFiles={uploadedFiles}
            fileConfigs={fileConfigs}
            previewFile={this.downloadFile}
            isDisabled={this.isDisabled}
          />

          <LogisticsDetail
            formRef={this.formRef}
            isDisabled={this.isDisabled}
            isIndia={pincodeLength === 6 ? true : false}
          />

          <FMEDetails
            formRef={this.formRef}
            handleChange={this.handleChange}
            handleSearch={this.handleSearch}
            onClear={this.onClear}
            fmeData={fmeData}
            isDisabled={this.isDisabled}
          />

          <AdditionalDetails
            formRef={this.formRef}
            editDataAvailable={editDataAvailable}
            editFormData={additional_details}
            isDisabled={this.isDisabled}
            isIndia={pincodeLength === 6 ? true : false}
          />

          <CustomFooter
            agreeTC={agreeTC}
            isInEdit={isInEdit}
            versionList={versionList}
            handleTC={(agreeTC) => this.setState({ agreeTC })}
          />
        </div>

        <BackTop />
      </Form>
    );
  }
}

export default CustomerListView;
